import { render, staticRenderFns } from "./ChannelConfigPage.vue?vue&type=template&id=8ae3457e&scoped=true"
import script from "./ChannelConfigPage.vue?vue&type=script&lang=js"
export * from "./ChannelConfigPage.vue?vue&type=script&lang=js"
import style0 from "./ChannelConfigPage.vue?vue&type=style&index=0&id=8ae3457e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ae3457e",
  null
  
)

export default component.exports